import AiRobot from 'assets/Icons/Ai/AiRobot';
import IcOpenAi from 'assets/Icons/Ai/IcOpenAi';
import IcArrowFillRoundRightBlue from 'assets/Icons/Arrow/IcArrowFillRoundRightBlue';
import IcArrowSquareRight from 'assets/Icons/Arrow/IcArrowSquareRight';
import IconArrowLineRight from 'assets/Icons/Arrow/Icon_arrowLine_right';
import ConnectCounsellor from 'assets/Icons/Counsel/AlarmNone copy';
import styled from 'styled-components';
import { Accent, BorderColor, TextColor } from 'styles/Global/colorSemantic';
import { Body3Bold, Body5Regular } from 'styles/Global/typography';

// React에서 선호하는 enum 방식
export const ServiceType = {
    AI_QUESTION: 'AI_QUESTION',
    COUNSEL_REQUEST: 'COUNSEL_REQUEST',
} as const;

export type ServiceTypeValue = (typeof ServiceType)[keyof typeof ServiceType];

interface ServiceConfig {
    title: string;
    description: string;
    icon: React.ComponentType;
}

const SERVICE_CONFIG: Record<ServiceTypeValue, ServiceConfig> = {
    [ServiceType.AI_QUESTION]: {
        title: 'ChatGPT에게 질문하기',
        description: '검사 결과에 대해 질문해보세요.',
        icon: IcOpenAi,
    },
    [ServiceType.COUNSEL_REQUEST]: {
        title: '심층상담 신청하기',
        description: '전문가와 1:1로 상담해보세요.',
        icon: ConnectCounsellor,
    },
};

interface ServiceButtonProps {
    type: ServiceTypeValue;
    onClick?: () => void;
}

export const ServiceButton: React.FC<ServiceButtonProps> = ({ type, onClick }) => {
    const config = SERVICE_CONFIG[type];
    const IconComponent = config.icon;

    return (
        <ButtonContainer onClick={onClick}>
            <InfoContainer>
                <IconWrapper size={50} as={IconComponent} />
                <InfoTextContainer>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <Body3Bold>{config.title}</Body3Bold>
                        {type === ServiceType.COUNSEL_REQUEST && <Body3Bold $color={Accent.color_accent_yellow_strong}>(유료)</Body3Bold>}
                    </div>
                    <Body5Regular>{config.description}</Body5Regular>
                </InfoTextContainer>
            </InfoContainer>
            <IcArrowSquareRight />
        </ButtonContainer>
    );
};

const ButtonContainer = styled.div`
    display: flex;
    border: 1px solid ${BorderColor.color_border_weak};
    padding: 16px 20px 16px 16px;
    border-radius: 8px;
    gap: 4px;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;
    &:hover {
        background-color: rgba(0, 0, 0, 0.02);
    }
`;

const IconWrapper = styled.div<{ size?: number }>`
    width: ${({ size }) => `${size}px` || '24px'};
    height: ${({ size }) => `${size}px` || '24px'};
    display: flex;
    align-items: center;
    justify-content: center;

    & > svg {
        width: 100%;
        height: 100%;
    }
`;

const InfoContainer = styled.div`
    display: flex;
    gap: 12px;
    padding: 2px 0px;
`;

const InfoTextContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
